import type { PageConfig } from "../types";

/**
 * THE EXAMPLE PAGE — copy this folder to make a new page.
 *
 *   1. Copy src/pages/example-page/ to src/pages/<your-page-name>/
 *      (kebab-case: the folder name becomes the URL, /<your-page-name>).
 *   2. Restart the dev server.
 *
 * That's it: the sidebar, landing page, route and LaunchDarkly flag
 * (mlFrontend-<your-page-name>, off until someone creates it) all come from
 * the folder name. To see the page locally while its flag is off, list it in
 * VITE_ML_FRONTEND_PREVIEW_PAGES in .env.local (or use `*` for every page).
 *
 * This folder itself is never listed in the sidebar (see TEMPLATE_PAGE_ID in
 * ../registry.ts); open /example-page to view it. Your copy is listed.
 *
 * This file only says how the page is listed. `title` is left out on purpose,
 * so a copy is titled after its own folder ("hub-map" → "Hub Map"); add one to
 * override it.
 */
export const page: PageConfig = {
  description: "An example page. Copy this folder to make a new one.",
  icon: "document",
  order: 1000,
};
